<div class="page-top">
  <div class="page-top__left">
    <div class="page-top__left--header">
      <h4 [attr.data-test]="'title-orderStatusPage'">{{ ('order-status-page.' + orderStatus + '.title') | translate }}</h4>
      <p class="description" [attr.data-test]="'desc-orderStatusPage'">
        {{ ('order-status-page.' + orderStatus + '.message') | translate }}
        @if ((isExternalQuoteCheckoutEnabled$ | async) && orderStatus !== EOrderStatusTypes.PAYMENT_PENDING) {
          {{ 'order-status-page.return-to-tpf' | translate }}
        }
      </p>
    </div>
  </div>
  <div class="page-top__right">
    <div class="page-top__right--header">
      <h4 [attr.data-test]="'title-haveQuestions'">
        {{ 'order-status-page.question.title' | translate }}
      </h4>
      <p class="description" [attr.data-test]="'desc-haveQuestions'">
        {{ 'order-status-page.question.description' | translate }}
      </p>
    </div>
    <div class="page-top__right--footer">
      <div *ngIf="'order-status-page.question.phone' | translate" class="contact">
        <span class="icon-phone"></span>
        <a href="tel:{{ 'order-status-page.question.phone' | translate }}"
           [attr.data-test]="'desc-contactPhone'">
          {{ 'order-status-page.question.phone' | translate }}
        </a>
      </div>
      <div *ngIf="'order-status-page.question.email' | translate" class="contact">
        <span class="icon-email"></span>
        <a href="mailto:{{ 'order-status-page.question.email' | translate }}"
           [attr.data-test]="'desc-contactEmail'">
          {{ 'order-status-page.question.email' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
@if (orderStatus !== EOrderStatusTypes.PAYMENT_PENDING) {
  <div class="page-bottom">
    <button type="button"
            class="button button--secondary"
            [attr.data-test]="'button-closeBrowserTab'"
            (click)="window.close()">
      {{ 'order-status-page.close-browser-tab' | translate }}
    </button>
  </div>
}
